import ArchiveComponent from "@/components/deals/archive";

export default function Archive() {
  return <ArchiveComponent />;
}
